// Theme resolution + persistence (REQ-DS-002). Pure logic + a thin DOM apply, so the
// precedence (persisted override > prefers-color-scheme) is jsdom-testable. The CSS in
// tokens.css does the actual theming; here we only stamp `data-theme` on the root.
export type Theme = "light" | "dark";

export interface ThemeStore {
  get(): string | null;
  set(v: string): void;
}

/** Persisted choice wins; otherwise follow the OS preference. */
export function resolveTheme(stored: string | null, prefersDark: boolean): Theme {
  if (stored === "light" || stored === "dark") return stored;
  return prefersDark ? "dark" : "light";
}

export function nextTheme(current: Theme): Theme {
  return current === "dark" ? "light" : "dark";
}

export function applyTheme(root: HTMLElement, theme: Theme): void {
  root.setAttribute("data-theme", theme);
}

/** Resolve + apply on boot; returns the active theme. */
export function initTheme(root: HTMLElement, store: ThemeStore, prefersDark: boolean): Theme {
  const t = resolveTheme(store.get(), prefersDark);
  applyTheme(root, t);
  return t;
}

/** Flip, persist the choice (making it a manual override), and apply. Returns the new theme. */
export function toggleTheme(root: HTMLElement, store: ThemeStore, current: Theme): Theme {
  const t = nextTheme(current);
  store.set(t);
  applyTheme(root, t);
  return t;
}
